type Invoke=(body:Record<string,unknown>)=>Promise<{data:any;error:unknown}>;
/** No storage/UI mutation here: a late reply must be discarded before creating a draft. */
export async function requestTeamBrief(scope:string,messages:unknown[],context:Record<string,unknown>,invoke:Invoke,isCurrent:()=>boolean):Promise<string|null>{
 const result=await invoke({teamDraftRequest:{mode:'prepare'},expectedScope:scope,messages:messages.slice(-20),consultantContext:context});
 if(!isCurrent())return null;
 if(result.error||result.data?.error)throw Error('draft_unavailable');
 if(result.data?.scope!==scope||result.data?.status!=='draft_ready'||typeof result.data.draft!=='string'||!result.data.draft.trim()||result.data.draft.length>3500)throw Error('draft_invalid');
 return result.data.draft;
}
